import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ActualRainfallModule } from './actual-rainfall/actual-rainfall.module';
import { FlowForecastModule } from './flow-forecast/flow-forecast.module';
import { ForecastRainfallModule } from './forecast-rainfall/forecast-rainfall.module';
import { ForecastWindspeedModule } from './forecast-windspeed/forecast-windspeed.module';
import { HeatWaveModule } from './heat-wave/heat-wave.module';
import { ThunderstormModule } from './thunderstorm/thunderstorm.module';
import { NowcastRainfallModule } from './nowcast-rainfall/nowcast-rainfall.module';
import { ColdwaveModule } from './coldwave/coldwave.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ActualRainfallModule,
    FlowForecastModule,
    ForecastRainfallModule,
    ForecastWindspeedModule,
    HeatWaveModule,
    ThunderstormModule,
    NowcastRainfallModule,
    ColdwaveModule
  ],
  exports: [
    ActualRainfallModule,
    FlowForecastModule,
    ForecastRainfallModule,
    ForecastWindspeedModule,
    HeatWaveModule,
    ThunderstormModule,
    NowcastRainfallModule,
    ColdwaveModule
  ]
})
export class WidgetGisModuleModule { }
